import { useEffect } from "react";
import { BrowserRouter as Router, useLocation } from "react-router-dom";
import Footer from "./components/sections/Footer/Footer";
import Navbar from "./components/sections/Navbar/Navbar";
import ProfileCover from "./components/sections/ProfileCover/ProfileCover";
import Sidebar from "./components/sections/Sidebar/Sidebar";

// Router v5 keeps the old scroll offset across route changes, which lands you mid-page
// on the new route. Reset to the top whenever the path changes.
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-bg text-text">
        <ProfileCover />
        <Sidebar />
        <main className="flex-1">
          <Navbar />
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
